import Details from "./company_away_details.router";
import Assignments from "./company_away_assignment.router";
import Applications from "./company_away_application.router";

export default [...Details, ...Assignments, ...Applications];
